const cloneRow = (v) => {
  if (!v || typeof v !== 'object') return v;
  return {
    ...v,
    values: Array.isArray(v.values) ? [...v.values] : v.values,
  };
};

export const cloneDocVariables = (vars) =>
  Array.isArray(vars) ? vars.map(cloneRow) : [];

const arrayValuesEqual = (a, b) => {
  const aa = Array.isArray(a) ? a : null;
  const bb = Array.isArray(b) ? b : null;
  if (aa === bb) return true;
  if (!aa || !bb) return !aa && !bb;
  if (aa.length !== bb.length) return false;
  return aa.every((slot, i) => String(slot ?? '') === String(bb[i] ?? ''));
};

export const docVariablesEqual = (a, b) => {
  if (a === b) return true;
  if (!Array.isArray(a) || !Array.isArray(b) || a.length !== b.length) return false;
  return a.every((v, i) => {
    const o = b[i];
    return (
      v &&
      o &&
      v.id === o.id &&
      v.name === o.name &&
      (v.type || 'string') === (o.type || 'string') &&
      (v.value || '') === (o.value || '') &&
      arrayValuesEqual(v.values, o.values) &&
      (v.description || '') === (o.description || '') &&
      v.color === o.color &&
      !!v.locked === !!o.locked &&
      (v.valueScope || 'doc') === (o.valueScope || 'doc')
    );
  });
};
